import { ApparelSizeTable } from '@components/ApparelSizeTable/ApparelSizeTable'
import { SizeGuideHeader } from '@components/SizeGuideHeader/SizeGuideHeader'
import { SizeGuideModalFooter } from '@components/SizeGuideModalFooter/SizeGuideModalFooter'
import type { ApparelSizeGuideJson } from '@velasca/types'
import { SansText } from '@velasca/ui/sans-text'
import { SansTitle } from '@velasca/ui/sans-title'
import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { indexToAlpha } from '@velasca/utils/index-to-alpha'
import { setQueryParams } from '@velasca/utils/set-query-params'
import {
  Circle,
  Img,
  Info,
  InfoImage,
  InfoText,
  Measure,
  MeasuresList,
  WrapSize,
} from './ApparelSizeGuide.styles'

const SIZES = [350, 420, 700, 840, 1050, 1260]

export const ApparelSizeGuide = ({
  sizeGuide,
  defaultMeasurementSystem,
  translations,
}: ApparelSizeGuideJson) => {
  const {
    topTitle,
    topText,
    footerTitle,
    footerText,
    firstButtonText = 'Misure in CM',
    secondButtonText = 'Misure in INCH',
    localizedSizesLabel,
    fitTitle,
    upperTitle,
  } = translations
  const {
    sizeGuideId,
    image,
    measures,
    description,
    textBeforeTable,
    textAfterTable,
    table,
  } = sizeGuide

  return (
    <>
      {sizeGuideId && (
        <>
          <WrapSize>
            <SizeGuideHeader title={topTitle} upperTitle={upperTitle} />
            <SansText center size="md" margin="0  0 4.5rem">
              {topText}
            </SansText>
            <Info>
              <InfoImage>
                {image?.src && (
                  <Img
                    lazyload
                    lqip
                    sources={buildIntrinsicWidthSources({
                      src: image.src,
                      maxWidth: image.width,
                      sizes: SIZES,
                    })}
                    imgSrc={setQueryParams(image.src, [
                      { name: 'width', value: '30' },
                    ])}
                  />
                )}
              </InfoImage>
              <InfoText>
                <MeasuresList>
                  {measures?.map((el, index) => (
                    <Measure key={index}>
                      <Circle>
                        <SansText
                          as="span"
                          fontWeight="500"
                          color="white"
                          margin="0.1rem 0 0 0"
                        >
                          {indexToAlpha(index)}
                        </SansText>
                      </Circle>
                      <SansText
                        size="md"
                        as="span"
                        fontWeight="500"
                        margin="1rem"
                      >
                        {el}
                      </SansText>
                    </Measure>
                  ))}
                </MeasuresList>
                <SansText center size="md">
                  {description}
                </SansText>
              </InfoText>
            </Info>
          </WrapSize>

          {textBeforeTable && (
            <>
              {fitTitle && (
                <SansTitle center as="h3" color="primary" size="sm">
                  {fitTitle}
                </SansTitle>
              )}
              <SansText
                center
                size="md"
                as="div"
                margin="1rem 0 3rem 0"
                dangerouslySetInnerHTML={{ __html: textBeforeTable }}
              />
            </>
          )}

          {table && (
            <ApparelSizeTable
              convertible
              table={table}
              localizedSizesLabel={localizedSizesLabel}
              firstButtonText={firstButtonText}
              secondButtonText={secondButtonText}
              defaultMeasurementSystem={defaultMeasurementSystem}
            />
          )}

          {textAfterTable && (
            <SansText
              margin="3rem 0 0 0"
              as="div"
              dangerouslySetInnerHTML={{ __html: textAfterTable }}
            />
          )}
        </>
      )}
      <SizeGuideModalFooter title={footerTitle} text={footerText} />
    </>
  )
}
